import * as React from 'react';

import { IListing } from '../../declarations';

import './ListingCardStyle.less';

export interface IListingCardProps {
  listing: IListing;
}

export default class ListingCard extends React.Component<IListingCardProps> {
  public render() {
    const { listing } = this.props;

    const firstListingPhoto = listing.listing_photos[0];
    const photoUrl = firstListingPhoto
      ? firstListingPhoto.thumbnail_urls._760x480
      : 'https://images.opendoor.com/source/s3/imgdrop-production/hvr-empty-home.png?service=consumer';

    const listingAddressString =
      listing.address.street1 + (listing.address.city ? `, ${listing.address.city}` : '');

    const listingDetailsString = [
      `${listing.bedrooms} bed ${listing.bathrooms} bath`,
      listing.square_footage && `${listing.square_footage} ft²`,
      listing.lot_square_footage && `${listing.lot_square_footage} ft² lot`,
    ]
      .filter(i => i)
      .join(' · ');

    return (
      <div className="listing-card">
        <div
          className="listing-photo"
          style={{
            backgroundImage: `url(${photoUrl})`,
          }}
        />
        <div className="listing-address">{listingAddressString}</div>
        <div className="listing-details">{listingDetailsString}</div>
      </div>
    );
  }
}
